import HeaderContext from './HeaderContext';
var HeaderConsumer = HeaderContext.Consumer;
export default HeaderConsumer;